import { render, staticRenderFns } from "./DashboardVertrieb.vue?vue&type=template&id=9c68c81c&scoped=true"
import script from "./DashboardVertrieb.vue?vue&type=script&lang=js"
export * from "./DashboardVertrieb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c68c81c",
  null
  
)

export default component.exports